import request from "utils/request";

export async function getBanner() {
  return request.get("/home/banner.php", "nocache");
}

export async function getRecommended() {
  return request.get("/home/recommended.php", "nocache");
}

export async function getTeacherList() {
  return request.get("/home/teacherListv2.php");
}

export async function getRecentLesson() {
  return request.get("/home/recentLesson.php");
}

export async function getTodayLesson() {
  return request.get("/home/todayLesson.php", "nocache");
}

export async function getLastAsset() {
  return request.get("/lesson/lastAsset.php", "nocache");
}

// 获取首页收藏的课件
export const getFavoriteList = () =>
  request.get("/materials/favoriteCourseware.php", "nocache");

export const getLayer = () => {
  return request.get("/home/layer.php", "nocache");
};

export async function getAppHomeVideo(data) {
  return request.post("wxampcard/appHomeVideo.php", data, "nocache");
}

export async function getAudioPreview(id) {
  return request.get(`my/audioPreview.php?audio_id=${id}`, "nocache");
}

export const getJumpLink = () => {
  return request.get("/my/getJumpLink.php", "nocache");
};

export const getAudioPreviewV3 = (data) => {
  return request.get(
    `/my/audioPreviewv3.php?category=${data.category || ""}&audio_id=${
      data.audio_id || ""
    }`,
    "nocache",
  );
};

export const getRefine = (config) => {
  return request.get("/home/refine.php", "nocache", config);
};
